import React from 'react'
import PropTypes from 'prop-types'
import FacebookSignIn from '../FacebookSignIn'
import { IconButton } from '../IconButton'

import { Facebook } from '@olxbr/ds-icons'
import { FacebookButton } from '@olxbr/ds-core'
import { isLoginScrollEnabled } from '../../../util/experiments'

const FacebookIconButton = ({
  onCancel,
  onError,
  onRequireEmail,
  onSubmit,
  onUserLoggedIn,
  lurker,
  tracker,
  facebookAppId,
  onPhoneNotValidatedError,
  onChallengePinCodeCall,
  abTests,
  sessionTokens,
  onAccountNotValidated,
  onAccountMustValidate,
  modalMode,
  onAccountSocialLoginTyping,
  onAccountCompleteData,
  ...restProps
}) => {
  const experimentOn = isLoginScrollEnabled(abTests)

  return (
    <FacebookSignIn
      onCancel={onCancel}
      facebookAppId={facebookAppId}
      onError={onError}
      onRequireEmail={onRequireEmail}
      onSubmit={onSubmit}
      onSuccess={onUserLoggedIn}
      lurker={lurker}
      tracker={tracker}
      onPhoneNotValidatedError={onPhoneNotValidatedError}
      onChallengePinCodeCall={onChallengePinCodeCall}
      render={({ onClick }) =>
        experimentOn ? (
          <FacebookButton
            onClick={onClick}
            size="medium"
            aria-label="Login Facebook"
            {...restProps}
          >
            Facebook
          </FacebookButton>
        ) : (
          <IconButton
            onClick={onClick}
            color="--color-neutral-70"
            customBgColor="#3a5998"
            size="large"
            aria-label="Login Facebook"
            {...restProps}
          >
            <Facebook />
          </IconButton>
        )
      }
      abTests={abTests}
      sessionTokens={sessionTokens}
      onAccountNotValidated={onAccountNotValidated}
      onAccountMustValidate={onAccountMustValidate}
      modalMode={modalMode}
      onAccountSocialLoginTyping={onAccountSocialLoginTyping}
      onAccountCompleteData={onAccountCompleteData}
    />
  )
}

FacebookIconButton.propTypes = {
  onCancel: PropTypes.func,
  onError: PropTypes.func,
  onSubmit: PropTypes.func,
  onUserLoggedIn: PropTypes.func,
  lurker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  tracker: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onPhoneNotValidatedError: PropTypes.func,
  onChallengePinCodeCall: PropTypes.func,
  abTests: PropTypes.string,
  sessionTokens: PropTypes.object, // eslint-disable-line react/forbid-prop-types
  onAccountNotValidated: PropTypes.func,
  modalMode: PropTypes.bool,
  onAccountSocialLoginTyping: PropTypes.func,
  onAccountCompleteData: PropTypes.func,
}

export { FacebookIconButton }
